import { react, useState } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Image from 'mui-image';
import { Link } from 'react-router-dom';
import './Navbar.css'
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import MailIcon from '@mui/icons-material/Mail';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SchoolIcon from '@mui/icons-material/School';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import SportsBarIcon from '@mui/icons-material/SportsBar';
import PermMediaIcon from '@mui/icons-material/PermMedia';


export default function Navbar(props) {
    const [state, setState] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const [navLink, setNavLink] = useState('Home');



    function navClicked(path) {
        setNavLink(path);
    };

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    function logout() {
        localStorage.removeItem('Login');
        sessionStorage.clear();
        props.LoginChanged();

    }

    function hasUserAccess(access) {

        try {
            return JSON.parse(localStorage.getItem('Login')).UserAccess.includes(access); // persists after window close
        }
        catch {

        }


        return null;
    }

    const createMenuList = (anchor) => (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List>
                <ListItem component={Link} key={'MenuLinkHome'} to='/Pickups' onClick={() => navClicked('Pickups')} className={navLink == 'Pickups' ? 'NavLinkSelected' : 'NavLink'}  disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <HomeIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Pickups'} />
                    </ListItemButton>
                </ListItem>
                <ListItem component={Link} key={'MenuLinkMyAccount'} to='/MyAccount' onClick={() => navClicked('MyAccount')} className={navLink == 'MyAccount' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <InfoIcon />
                        </ListItemIcon>
                        <ListItemText primary={'My Account'} />
                    </ListItemButton>
                </ListItem>
                <ListItem component={Link} key={'MenuLinkTraining'} to='/Training' onClick={() => navClicked('Training')} className={navLink == 'Training' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <SchoolIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Training'} />
                    </ListItemButton>
                </ListItem>
                <ListItem component={Link} key={'MenuLinkBrandLookupo'} to='/BrandLookup' onClick={() => navClicked('BrandLookup')} className={navLink == 'BrandLookup' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <img src='images/BrandLookupIcon.png' style={{ width: '32px', alignSelf: 'center' }} />
                        </ListItemIcon>
                        <ListItemText primary={'Brand Lookup'} />
                    </ListItemButton>
                </ListItem>
                <ListItem component={Link} key={'MenuLinkMarketing'} to='/Marketing' onClick={() => navClicked('Marketing')} className={navLink == 'Marketing' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <PermMediaIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Marketing'} />
                    </ListItemButton>
                </ListItem>
                <ListItem component={Link} key={'MenuLinkContactUs'} to='/ContactUs' onClick={() => navClicked('ContactUs')} className={navLink == 'ContactUs' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <MailIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Contact Us'} />
                    </ListItemButton>
                </ListItem>

                <ListItem component={Link} key={'MenuLinkStore'} to='/Store' onClick={() => navClicked('Store')} className={navLink == 'Store' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            
                            <img src='images/StoreIcon.png' style={{ width: '32px', alignSelf: 'center' }} />
                        </ListItemIcon>
                        <ListItemText primary={'Store'} />
                    </ListItemButton>
                </ListItem>
               
                <Divider />
                <ListItem component={Link} key={'MenuLinkLogout'} onClick={() => logout()} className={navLink == 'Logout' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <LogoutIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Logout'} />
                    </ListItemButton>
                </ListItem>

                {hasUserAccess('ADMIN') ?
                    <ListItem key={'MenuAdmin'} component={Link} to='/Admin' disablePadding style={{ marginTop: '50px' }}>
                        <ListItemButton>
                            <ListItemIcon>
                                <SportsBarIcon />
                            </ListItemIcon>
                            <ListItemText primary={'Admin'} />
                        </ListItemButton>
                    </ListItem>
                    : null}
            </List>
        </Box>
    );

    return (
        <div>
            <Drawer open={state['left']} onClose={toggleDrawer('left', false)} >
                {createMenuList('left')}
            </Drawer>
            <AppBar position="static">
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={toggleDrawer('left', true)}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                        </Box>

                        
                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                            <Button
                                component={Link}
                                onClick={() => navClicked('Pickups')}
                                to='/Pickups'
                                key={'NavLinkPickups'}
                                sx={
                                    {
                                        my: 2,
                                        display: 'block'
                                    }
                                }
                                className={navLink == 'Pickups' ? 'NavLinkSelected' : 'NavLink'}
                            >
                                Pickups
                            </Button>
                            <Button
                                component={Link}
                                onClick={() => navClicked('MyAccount')}
                                to='/MyAccount'
                                key={'NavLinkMyAccount'}
                                sx={{ my: 2, display: 'block' }}
                                className={navLink == 'MyAccount' ? 'NavLinkSelected' : 'NavLink'}
                            >
                                My Account
                            </Button>
                          
                            <Button
                                component={Link}
                                to='/Training'
                                key={'NavLinkTraining'}
                                onClick={() => navClicked('Training')}
                                sx={{ my: 2, display: 'block' }}
                                className={navLink == 'Training' ? 'NavLinkSelected' : 'NavLink'}
                            >
                               Training
                            </Button>
                            <Button
                                component={Link}
                                to='/BrandLookup'
                                key={'NavLinkBrandLookup'}
                                onClick={() => navClicked('BrandLookup')}
                                sx={{ my: 2, display: 'block' }}
                                className={navLink == 'BrandLookup' ? 'NavLinkSelected' : 'NavLink'}
                            >Brand Lookup
                            </Button>
                            <Button
                                component={Link}
                                to='/Marketing'
                                key={'NavLinkMarketing'}
                                onClick={() => navClicked('Marketing')}
                                sx={{ my: 2, display: 'block' }}
                                className={navLink == 'Marketing' ? 'NavLinkSelected' : 'NavLink'}
                            >
                                Marketing
                            </Button>
                            <Button
                                component={Link}
                                to='/ContactUs'
                                key={'NavLinkContactUs'}
                                onClick={() => navClicked('ContactUs')}
                                sx={{ my: 2, display: 'block' }}
                                className={navLink == 'ContactUs' ? 'NavLinkSelected' : 'NavLink'}
                            >Contact Us
                            </Button>
                            <Button
                                component={Link}
                                to='/Store'
                                key={'NavLinkStore'}
                                onClick={() => navClicked('Store')}
                                sx={{ my: 2, display: 'block' }}
                                className={navLink == 'Store' ? 'NavLinkSelected' : 'NavLink'}
                            >Store
                            </Button>
                            <Button
                                component={Link}
                                
                                key={'NavLinkLogout'}
                                onClick={() => logout()}
                                sx={{ my: 2, display: 'block' }}
                                className={navLink == 'Logout' ? 'NavLinkSelected' : 'NavLink'}
                            >
                                Logout
                            </Button>
                            {hasUserAccess('ADMIN') ?
                                <Button
                                    component={Link}
                                    to='/Admin'
                                    key={'NavLinkAdmin'}
                                    onClick={() => navClicked('Login')}

                                    sx={{ my: 2, display: 'block', marginLeft: '100px' }}
                                    className={navLink == 'Login' ? 'NavLinkSelected' : 'NavLink'}
                                >
                                    Admin
                                </Button>
                                : null}
                        </Box>
                        <Image src="images/Sipzee white TM.png" width={128} height={50} />
                    </Toolbar>
                </Container>
            </AppBar>
        </div>
    );
}
